// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2uh_Y","column":"style_column__R12LJ","row":"style_row__27chE"};